function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#F9B8A2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.3668 13.6332C22.8552 10.1223 17.1442 10.1223 13.6326 13.6332C10.1225 17.1441 10.1225 22.8565 13.6326 26.3674C15.3884 28.1225 17.6942 28.9996 20.0001 28.9996C22.306 28.9996 24.611 28.1224 26.3668 26.3674C29.8777 22.8565 29.8777 17.1441 26.3668 13.6332ZM23.7136 22.6532C24.0069 22.9465 24.0069 23.4208 23.7136 23.7141C23.5672 23.8605 23.3752 23.934 23.1831 23.934C22.991 23.934 22.7989 23.8605 22.6525 23.7141L20.0001 21.0609L17.3483 23.7134C17.2013 23.8597 17.0091 23.9332 16.8178 23.9332C16.6257 23.9332 16.4336 23.8597 16.2873 23.7134C15.9939 23.42 15.9939 22.945 16.2873 22.6524L18.939 19.9999L16.2866 17.3474C15.9932 17.054 15.9932 16.5791 16.2866 16.2864C16.5792 15.9931 17.0542 15.9931 17.3475 16.2864L20 18.9389L22.6525 16.2864C22.9459 15.9931 23.4201 15.9931 23.7135 16.2864C24.0069 16.5791 24.0069 17.054 23.7135 17.3474L21.061 19.9999L23.7136 22.6532Z",
  fill: "#EC6161"
});

var SvgCancelrequest = function SvgCancelrequest(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCancelrequest, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cancelrequest.3ac36d70.svg";
export { ForwardRef as ReactComponent };